import { Dispatch } from 'redux';
import { api } from '../../../App';
import { authActions } from '../auth.reducer';
import { registrationActions } from '../../registration/registration.reducer';

export const logOut = () => async (dispatch: Dispatch) => {
  await api.service.apiCookieLogoutPost();

  dispatch(authActions.resetState());
  dispatch(registrationActions.resetRegistration());
  console.log("User was logged out.")
};
